"use client";

import { Toast } from "@base-ui/react/toast";

export const anchoredToastManager = Toast.createToastManager();

export function AnchoredToastProvider() {
  return (
    <Toast.Provider toastManager={anchoredToastManager}>
      <AnchoredToasts />
    </Toast.Provider>
  );
}

function AnchoredToasts() {
  const { toasts } = Toast.useToastManager();

  return (
    <Toast.Portal>
      <Toast.Viewport className='tw-outline-none'>
        {toasts.map(toast => (
          <Toast.Positioner key={toast.id} toast={toast} className='tw-z-[calc(1000-var(--toast-index))]'>
            <Toast.Root
              toast={toast}
              className='tw-origin-[var(--transform-origin)] data-[ending-style]:tw-opacity-0 data-[starting-style]:tw-scale-90 data-[starting-style]:tw-opacity-0 focus-visible:tw-outline-focus tw-group tw-flex tw-w-max tw-flex-col tw-rounded-lg tw-bg-black tw-text-white tw-p-2 tw-transition'
            >
              <Toast.Content>
                <Toast.Description className='tw-type-2xs' />
              </Toast.Content>
            </Toast.Root>
          </Toast.Positioner>
        ))}
      </Toast.Viewport>
    </Toast.Portal>
  );
}
